import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[eventTracker]'
})
export class AnalyticsDirective {

  @Input('eventTracker') option:any;

  @HostListener('click', ['$event']) onClick($event){
    if(this.option.category && this.option.label && this.option.action){
      if(typeof(this.option.action)=='object'){
        if(this.option.action.length>0){
          for (let a of this.option.action) {
            this.sendEventGtag(this.option.category, a, this.option.label, this.option.value);
            this.sendGAEvent(this.option.category, a, this.option.label, this.option.value);
          }
        }
      }else{
        if(this.option.action!=undefined || this.option.action!=""){
          this.sendEventGtag(this.option.category, this.option.action, this.option.label, this.option.value);
          this.sendGAEvent(this.option.category, this.option.action, this.option.label, this.option.value);
        }
      }
    }
  }
  
  sendEventGtag(c:string, a:string,l:string, v:string){
    try{
      var oldDataLayer = (<any>window).oldDataLayer = (<any>window).oldDataLayer || [];
      oldDataLayer.push('event', a, {
        'event_category':c,
        'event_label'   :l,
        'value'         :v
      });
    } catch (e){
      console.log(e);
    }
  }

  sendGAEvent(category: string, action: string, label: string, value: string) {
    try {
      var dataLayer = (<any>window).dataLayer = (<any>window).dataLayer || [];
      dataLayer.push({
        'event': category,
        'event_action': action,
        'event_value': value
      });
    } catch (e) {
      console.log(e);
    }
  }

  constructor() { }

}